<template>
	<div style="width: 100%">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="search()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="商品信息：">
				<el-cascader v-model="typeKeyId" size="small" :options="goodsTypeList" :props="cascaderProps" placeholder="请选择商品信息" clearable filterable @change="changeType"></el-cascader>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData"></STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetAllGoodsTypeTreePageList } from "@/api/baseDataApi.js";
import { GetWareHouseQtySnapshotPageList } from "@/api/storeOrderApi.js";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				goodsTypeKeyId: ""
			},
			typeKeyId: "",
			goodsTypeList: [],
			cascaderProps: {
				value: "keyId",
				label: "name",
				children: "subList",
				checkStrictly: false,
				expandTrigger: "hover"
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "goodsTypeName",
					label: "商品类型",
					align: "center"
				},
				{
					prop: "beforeQuantity",
					label: "原数量",
					align: "center"
				},
				{
					prop: "beforeCreator",
					label: "原数量操作人",
					align: "center"
				},
				{
					prop: "beforeTime",
					label: "原数量操作时间",
					align: "center"
				},
				{
					prop: "afterQuantity",
					label: "维护后数量",
					align: "center"
				},
				{
					prop: "afterCreator",
					label: "维护后操作人",
					align: "center"
				},
				{
					prop: "afterTime",
					label: "维护后操作时间",
					align: "center"
				},
				{
					prop: "stateStr",
					label: "状态",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetAllGoodsTypeTreePageList();
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取商品类型数据
		GetAllGoodsTypeTreePageList() {
			GetAllGoodsTypeTreePageList({})
				.then((res) => {
					if (res.code == 1) {
						this.goodsTypeList = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		changeType(value) {
			if (value && value.length > 0) {
				this.formInline.goodsTypeKeyId = value[value.length - 1];
			} else {
				this.formInline.goodsTypeKeyId = "";
			}
			this.search();
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetWareHouseQtySnapshotPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.typeKeyId = "";
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
